import { map } from 'rxjs/operators';

import apiService from '../api';
import type { ApiService } from '../api';

class ExportService {
  constructor(private apiService: ApiService) {}

  public getListEmailsAllowedToExport(): Promise<string[]> {
    return this.apiService
      .get('/reports/export/email-recipients')
      .pipe(map(response => response.data.emails))
      .toPromise();
  }
}

const exportService = new ExportService(apiService);
export default exportService;
